export var config = {
  auth: {
    login: 'auth/login',
    signup: 'auth/register',
    verify: 'auth/login/verifyOtp',
    logout: 'auth/logout',
    getEncryptionMode: 'site-settings',
    forgetPassword: {
      forgetEmail: 'forget',
      verifyLink: 'cheklinkstatus',
      changePassword: 'auth/forgotPasswordEmail',
      resetPassword: 'auth/sendOtp',
      verifyOtp: 'auth/verifyOtp',
    },
    // getuserprofile: 'auth/view-profile',
    getuserprofile: 'auth/user/user-prefix-details',

    getpermission: 'api/allpermissionlist',
    havepermission: 'api/have_permission',
    Addpermission: 'api/user_revokepermission',
    getNotification: 'auth/notifications-count',
    role_permission: 'api/role_permission',
    add_role: 'api/role_revokepermission',
    getrole: 'api/getrolelist',
    getpermissionrole: 'api/allpermissionlistbyrole',
    kycStatus: 'auth/kyc-status',
    businessName: 'auth/get-bussiness-name',
    changePassword: 'auth/changePassword',
    updateProfile: 'auth/user/update-profile',
    verifyOtp: 'auth/user/verify-otp',
  },
  Api_Key: {
    getList: 'credentials/keys',
    deactiveKey: 'credentials/deactivate-key',
    pkyUpdate: 'credentials/publickeyCreateUpdate',
    certificateKey:'credentials/certificate-create-update',
    createApiKey: 'credentials/generate-key',
    sendOTP: 'auth/send-user-otp',
    sendCredEmail: 'credentials/send_cred_email',
    config: 'credentials/update-config',
    getConfig: 'credentials/get-config',
    verifyOTP: 'auth/verify-user-otp',
    addIp:'credentials/add-ip',
    getIp:'credentials/get-ip'

  },
  // uploadFile: {
  //   url: "upload-file",
  // },

  payout: {
    create_beneficiary: 'v2/payout/create-beneficiary',
    get_beneficiary: 'v2/payout/beneficiary-list',
    // make_payment: 'payout/payment',
    make_payment: 'v2/payout/payment',
    payoutOtp: 'v2/payout/send-payout-otp',
    payment_stmt: 'payout/payout-statement',
    export_payment_stmt: 'payout/export-payout-statement',
    payoutSingle: 'payout/payout-count',
    verifyBeni: 'v2/payout/verify-beneficiary',
    // payoutStatus: 'payout/get-payout-status'
    payoutStatus: 'v2/payout/payout-status',
    getCallback: 'v2/payout/get-callback',
    beniCount: 'v2/payout/beneficiary-count',

    updatebane: 'payout/update-bene',
    getEditBeniId: 'payout/get-beneficiary',
    updatebenedata: 'payout/update-beneficiary',
    addUrnRrn: 'payout/add-urn-rrn',
  },
  bankAccList: {
    url: 'service/get-account-lists',
    bank_list: 'auth/get-all-banks',
  },

  dashboard: {
    dashboard_api: '/api/dashboard',
    pie_chart: '/api/piechart',
    bar_graph: '/api/graphchart',
    service: 'service/get-service'
  },
  ticketing: {
    raise: {
      //general issues start
      support_type: 'ticket/get-support-types',
      request_type: 'ticket/get-request-types',
      //general issues end

      //txn issues start
      get_services: 'ticket/get-services',
      txn_issues: "ticket/get-txn-issues",
      //txn issues end

      universal_form: 'ticket/view-universal-form',
      raise_ticket: 'ticket/raise-ticket',
    },
    track: {
      my_tickets: 'ticket/my-tickets',
      get_ticket_details: 'ticket/get-ticket-details',
      add_comment: 'ticket/add-comment-to-ticket',
      close_ticket: 'ticket/close-ticket',
      reopen_ticket: 'ticket/reopen-ticket',


    },

  },
  verify_dashboard: {
    dashboard_api: 'v2/payout/all-accounts',
    // single_account: 'dashboard/get-dashboard-accounts',
    single_account: 'v2/payout/balance-fetch',

    
    dashboardData: 'dashboard/dashboard-count',
    bussniessTrend: 'dashboard/bussniess-trend',
    dashboardPayoutCount: 'dashboard/payout-count',
    dashboardVaTxnCount: 'dashboard/va-transactions-count',
    dashboardUpiCount: 'dashboard/merchant-upi-count',
    dashboardDetail: 'dashboard/dashboard-detail',
    payoutGraph: 'dashboard/payout-graph-data',
    collectionGraph: 'dashboard/collection-graph-data',
    getAllDashboardStats: 'dashboard/get-dashboard-stats',
  },
  createBank: {
    userAccountList: 'bank/user-account-list',
    getAccountDetails: 'bank/user-account',
    // getAccountDetails: 'bank/getAccountDetails',
    getbanks: 'bank/banklist',
    getBankForm: 'bank/getbankForm',
    add_bank_account: 'bank/add-bank-account',
    get_account_type: 'bank/account-types',
  },
  bankCrednitial: {
    getFormdata: 'bank/get-formdata',
    addBankCrednitial: 'bank/add-bank-crednitial',
    getCrednitial: 'bank/get-crednitial',
    deleteCrednitial: 'bank/delete-crednitial',
    editCrednitial: 'bank/edit-bank-crednitial',
  },
  header: {
    getbalance: 'api/getbalance',
  },

  sidemenu: {
    // live: 'permissions/leftPanel',

    live: 'permissions/leftPanelV2',
    topPanel: 'permissions/top-panel',
  },

  apikey: {
    key: '/api/getapikeyslist',
  },

  // fileUpload: {
  //   upload: '/api/upload-file',
  // },

  qr: {
    qrGenerate: 'v2/qr/create-qr',
    getActiveVpaList: 'qr/get-active-vpa',
    getVpaDetails: 'qr/get-vpa-details',
    getQrLogo: 'qr/qr-logos',
    saveQrLogo: 'qr/save-qr-logo',
    QrStatement: 'qr/statement',
    QrSingleStatement: 'qr/single-statement',
    qrTransaction: 'qr/transactions',
    vpaReport: 'qr/vpa-report',
    exportQrTxn: 'qr/export-qr-txn',
    exportVpaReport: 'qr/export-vpa-report',
    getSuffix: 'qr/get-suffix',
    delete_logo: 'qr/delete-logo',
    updateVpa: 'qr/update-vpa',
    qaExport: 'qr/export-qa-accn-txn',
    qrStatus: 'qr/qr-status',
    getCallback: 'qr/get_payin_callback',
    getDynamicForm: 'service/get-dynamic-form',
  },

  va: {
    VaStatement: 'va/list',
    vaGenerate: 'va/create-va',
    VaSignlestatement: 'va/statement',
    getprefix: 'va/get-prefix',
    vaTransaction: 'va/transactions',
    updateVa: 'va/update-va',
    updateStatus: 'va/approve-transaction',
    vaExport: 'va/export-va-accn',
    vaStatementExport: 'va/export-va-accn-txn',
    viewUploadedReq: 'va/viewVaUploads',
    uploadBulkFile: 'bulkUpload',
    vaAccUserList: 'va-acc-user-list',
    whiteListAccountList: 'white-list-account-list',
    whiteListAccountDelete: 'delete-whitelist-account',
    allBanksList: 'all-banks-list',
    addWhitelistAccount: 'add-whitelist-account',
    updateWhitelistAccount: 'update-whitelist-account',
  },

  statement: {
    // accountstatement: 'auth/accountstatement',
    accountList: 'dashboard/get-account',
    accountstatement: 'v2/payout/account-statement',
  },
  reports: {
    reports: 'report/all-requests',
    CreateReport: 'report/request',
  },
  reportsNew: {
    payoutNew: 'payout/payout-statement',
    download: 'payout/export-payout-statement',
    filter: '/bank/banklist',
    getTxnIssues: '/ticket/get-txn-issues'
  },
  walletStatmentReports: {
    walletStatmentDownload: 'auth/wallet-transactions-downloads',
    walletTransaction: 'auth/wallet-transactions'
  },
  ecollect: {
    ecollectReport: 'va/transactions',
    ecollectDownload: 'va/export-va-accn-txn'
  },
  upiCollection: {
    upiCollectionReport: 'qr/transactions',
    upiCollectionExport: 'qr/export-qr-txn'
  },
  beneficiary: {
    beneficiaryReport: 'v2/payout/beneficiary-list',
    beneficiaryExport: 'v2/payout/beneficiary-export'
  },
  vpacreation: {
    getVpaReport: 'qr/vpa-report',
    exportVpaReport: 'qr/export-vpa-report'
  },

  kyc: {
    basicDetails: 'api/basicDetail',
    entityType: 'api/entityType',
    bankType: 'api/mbanks',
    ifscType: 'api/getIfsc',
    pennydrop: 'api/pennydrop',
    panVerify: 'api/panverify',
    aadhaarSendOtp: 'api/aadhaarSendOtp',
    aadhaarVerifyOtp: 'api/aadhaarVerifyOtp',
    upadateData: 'api/updateData',
    allKycDetails: 'api/allKycDetails',
    adminApprove: 'api/docApprove',
  },

  location: {
    stateData: 'api/getAllState',
    cityData: 'api/getAllCity',
  },

  qrCreate: {
    url: 'api/createVpa',
  },

  pincode: {
    url: 'auth/get-pincode',
  },

  notification: {
    list_url: 'auth/notifications',
    readNotification: 'auth/notification-read',
    notificationContent: 'auth/notification-content-list',
  },

  wallet: {
    walletDetails: 'auth/wallet',
    walletUpdate: 'auth/update-wallet',
    walletStatement: 'auth/wallet-transactions',
    billPurchase: 'auth/wallet-transactions',
    suppliers: 'auth/wallet-transactions',
    downloadWalletStm: 'auth/wallet-transactions-downloads',
  },
  bbps: {
    getBillerCatogryList: 'bbps/getBillerCategoryList',
    getBillerOpratorList: 'bbps/getBillerOperatorList',
    // getValidate: 'bbps/validateBillDetail',
    getValidate: 'bbps/bill-fetch',

    getInitiateBillPayment: 'bbps/initiateBillPayment'
  },
  bbpsDash: {
    getBillpayList: 'bbps/billpay-statement',
    getdownloadData: 'bbps/download-billpay-statement',
    getComplaintDesposile: 'bbps/complain-disposition-list',
    createComplaint: 'bbps/create-complain',
    checkComplaintStatus: 'bbps/check-complain-status',
    trackComplaint: 'bbps/complain-track'
  },
  tokenauth: 'e090c25187ee2b3f9f1f8a02747356641',
  Authkey: 'MWQyMmUzNWY4YjhlNjY2NWJjM2EzZjY0NjNhZWM0ZTk=',
};
